module.exports = __webpack_public_path__ + "static/media/findCE.2e5c58f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/findCE.jpg
// module id = 355
// module chunks = 0